import React, { useEffect } from 'react'
import CommunityList from '~/pages/community/CommunityList'
import CommunityListSidebar from '~/pages/community/CommunityListSidebar'
import { SizeBreakpoint } from '~/common/hooks/useWindowSize'
import ColumnLayout from '~/common/ColumnLayout'
import { useTitle } from '~/common/hooks/useTitle'
import { LocalStorageKey } from '~/types'

export enum CommunityListTab {
  All = 'All',
  My = 'My',
  Recommended = 'Recommended',
  VeevaOnly = 'Veeva Only',
}

const CommunityListLayout = ({ communityListTab }: { communityListTab?: CommunityListTab }) => {
  const communityTab = (localStorage.getItem(LocalStorageKey.communityTab) as CommunityListTab) ?? CommunityListTab.All

  const commTab = communityListTab || communityTab
  useTitle(`Communities - ${commTab} - Veeva Connect`)
  useEffect(() => {
    if (communityListTab) {
      localStorage.setItem(LocalStorageKey.communityTab, communityListTab)
    }
  }, [communityListTab])

  return (
    <>
      <ColumnLayout threshold={SizeBreakpoint.md} currentPage={'comm'} additionalColumnClass={'comm-list'}>
        <CommunityListSidebar communityListTab={commTab} />
        <CommunityList communityListTab={commTab} />
      </ColumnLayout>
    </>
  )
}

export default CommunityListLayout
